import React from 'react';
import { makeStyles } from '@material-ui/styles';
const useLabelStyles = (props) => makeStyles({
    valueLabel: {
        fontFamily: 'Gotham',
        fontSize: '14px',
        minWidth: '30px',
        letterSpacing: '-0.56px',
        color: props.color,
        maxWidth: '45%',
        '@media only screen and (max-width : 480px)': {
            fontSize: '12px',
        },
    },
    maxminContainer: {
        display: 'flex',
        justifyContent: 'space-between',
    },
    minLabel: {
        textAlign: 'left',
    },
    maxLabel: {
        textAlign: 'right',
    },
    after: {
        marginTop: 15,
        paddingTop: 15,
        '@media only screen and (max-width : 500px)': {
            marginTop: 12,
            paddingTop: 12,
        },
    },
    before: {
        marginTop: -38,
    },
});
const Labels = ({ minLabel, maxLabel, labelsPosition, color, }) => {
    const classes = useLabelStyles({ color })();
    return (React.createElement("div", { className: `${classes.maxminContainer} ${classes[labelsPosition]}` },
        React.createElement("span", { className: `${classes.valueLabel} ${classes.minLabel}` }, minLabel),
        React.createElement("span", { className: `${classes.valueLabel} ${classes.maxLabel}` }, maxLabel)));
};
export default Labels;
